import { render, staticRenderFns } from "./sales-person-screen.vue?vue&type=template&id=d2338b9a&"
import script from "./sales-person-screen.vue?vue&type=script&lang=js&"
export * from "./sales-person-screen.vue?vue&type=script&lang=js&"
import style0 from "./sales-person-screen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports